import {
  Checkbox,
  Col,
  Dropdown,
  Form,
  FormInstance,
  Menu,
  Radio,
  Row,
  Space,
  Typography,
} from 'antd';
import ReportSelectMonthFields, {
  ReportDateInterface,
} from '@/components/_common/ReportSelectMonthFields';
import {
  DeliveryOfMaterialFormValues,
  StockSelectReportType,
  StockType,
} from '@/core/domain/reports/stock/DeliveryOfmaterial/DeliveryOfmaterial.types';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';
import DeliveryOfMaterialOptionsEmployessVsInputs from './DeliveryOfMaterialOptionsEmployessVsInputs';
import DeliveryOfMaterialMoreOptions from './DeliveryOfMaterialMoreOptions';
import { Info } from 'react-feather';

interface Props {
  form: FormInstance<DeliveryOfMaterialFormValues & ReportDateInterface>;
}

const DeliveryOfMaterialForm = ({ form }: Props) => {
  const intl = useIntl().formatMessage;
  const { Title } = Typography;

  const expensesIndividuallyMenu = (
    <Menu mode="vertical" style={{ width: 300 }}>
      <Menu.Item key={1}>
        {intl({
          id: 'stock.DeliveryOdMaterial.form.type.info',
        })}
      </Menu.Item>
    </Menu>
  );

  return (
    <Form layout="vertical" form={form}>
      <ReportSelectMonthFields form={form} />

      <Row gutter={[24, 24]}>
        <Col xs={24}>
          <Title level={5}>
            {intl({
              id: 'stock.DeliveryOdMaterial.form.selectReportType',
            })}
          </Title>
          <Form.Item
            name="reportType"
            initialValue={StockSelectReportType.delivery}
          >
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={StockSelectReportType.delivery}>
                {intl({
                  id: 'stock.DeliveryOdMaterial.form.selectReportType.delivery',
                })}
              </Radio>
              <Radio value={StockSelectReportType.return}>
                {intl({
                  id: 'stock.DeliveryOdMaterial.form.selectReportType.return',
                })}
              </Radio>
              <Radio value={StockSelectReportType.employeesVsInputs}>
                {intl({
                  id: 'stock.DeliveryOdMaterial.form.selectReportType.employeesVsInputs',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Form.Item shouldUpdate>
            {({ getFieldValue }) => {
              const cestLength = getFieldValue('reportType');

              return cestLength !== 'EmployeePerConsumable' ? (
                <FloatingFormItem name="showEmployee" valuePropName="checked">
                  <Checkbox>
                    {intl({
                      id: 'stock.DeliveryOdMaterial.form.employeesVsInputs',
                    })}
                  </Checkbox>
                </FloatingFormItem>
              ) : (
                <DeliveryOfMaterialOptionsEmployessVsInputs />
              );
            }}
          </Form.Item>
        </Col>

        <Col xs={24}>
          <Space align="center">
            <Title level={5}>
              {intl({
                id: 'stock.DeliveryOdMaterial.form.type',
              })}
              <Dropdown
                overlay={expensesIndividuallyMenu}
                trigger={['click']}
                arrow
                placement="topCenter"
              >
                <Info size={20} id="note-type-icon" cursor={'pointer'} />
              </Dropdown>
            </Title>
          </Space>
          <Form.Item name="type" initialValue={StockType.stockist}>
            <Radio.Group optionType="button" buttonStyle="solid" size="large">
              <Radio value={StockType.employee}>
                {intl({
                  id: 'stock.DeliveryOdMaterial.form.type.employee',
                })}
              </Radio>
              <Radio value={StockType.stockist}>
                {intl({
                  id: 'stock.DeliveryOdMaterial.form.type.stockist',
                })}
              </Radio>
            </Radio.Group>
          </Form.Item>
        </Col>

        <Col xs={24}>
          <DeliveryOfMaterialMoreOptions form={form} />
        </Col>
      </Row>
    </Form>
  );
};

export default DeliveryOfMaterialForm;
